module.exports = __webpack_public_path__ + "static/img/010.4a6bf79f.png";